import CategoryPage from "./CategoryPage";

export default function SeriesPage() {
  return (
    <CategoryPage
      title="Series"
      layout="portrait"
      pick={(c) => ({ streams: c.series.streams, categories: c.series.categories })}
      hrefFor={(s) => `/series/${encodeURIComponent(s.id)}`}
    />
  );
}
